export enum DownloadState {
  DEFAULT = 'default',
  DOWNLOADING = 'downloading',
  DOWNLOADED = 'downloaded',
}
